import { motion } from 'framer-motion'
import styled from 'styled-components'

const StModalBackdrop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);

  ${({ theme }) => {
    const modalTheme = theme.Components.Modal

    return `
        width: 100%;
        height: 100%;
        background-color: ${modalTheme.Backdrop};
    `
  }};
`

const AnimatedStModalBackdrop = motion(StModalBackdrop)

export { AnimatedStModalBackdrop, StModalBackdrop }
